import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "customizing-content-card-templates"
    }}>{`Customizing Content Card Templates`}</h1>
    <p>{`This tutorial explains how to customize the UI of content card in your application.`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Messaging extension provides a way to customize content cards based on the template type. You can customize the content card templates using the `}<a parentName="p" {...{
        "href": "../public-classes/contentcardcustomizing.md"
      }}>{`ContentCardCustomizing`}</a>{` protocol.`}</p>
    <h2 {...{
      "id": "implementing-contentcardcustomizing"
    }}>{`Implementing ContentCardCustomizing`}</h2>
    <p>{`Perform the following steps to customize content card templates:`}</p>
    <ol>
      <li parentName="ol">{`Conform to the ContentCardCustomizing protocol in your class or struct.`}</li>
      <li parentName="ol">{`Implement the desired methods of the ContentCardCustomizing protocol.`}</li>
    </ol>
    <p>{`Below is an example implementation of `}<inlineCode parentName="p">{`ContentCardCustomizing`}</inlineCode>{`. In this example, the `}<inlineCode parentName="p">{`HomePageCardCustomizer`}</inlineCode>{` class conforms to the `}<inlineCode parentName="p">{`ContentCardCustomizing`}</inlineCode>{` protocol and customizes the `}<inlineCode parentName="p">{`SmallImageTemplate`}</inlineCode>{` content card template:`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages="Swift" mdxType="CodeBlock" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`class HomePageCardCustomizer: ContentCardCustomizing {
    
    func customize(template: SmallImageTemplate) {
        // customize UI elements
        template.title.textColor = .primary
        template.title.font = .subheadline
        template.body?.textColor = .secondary
        template.buttons?.first?.text.font = .system(size: 13)
        
        // customize stack structure
        template.rootHStack.spacing = 15
        template.textVStack.alignment = .leading
        template.textVStack.spacing = 10
        
        // add custom modifiers
        template.buttonHStack.modifier = AEPViewModifier(ButtonHStackModifier())
        template.rootHStack.modifier = AEPViewModifier(RootHStackModifier())
        
        // customize the dismiss buttons
        template.dismissButton?.image.iconColor = .primary
        template.dismissButton?.image.iconFont = .system(size: 10)
    }
    
    struct RootHStackModifier : ViewModifier {
        func body(content: Content) -> some View {
             content
                .frame(maxWidth: .infinity, alignment: .leading)
                .padding(.trailing)
         }
    }
    
    struct ButtonHStackModifier : ViewModifier {
        func body(content: Content) -> some View {
             content
                .frame(maxWidth: .infinity, alignment: .trailing)
         }
    }
}
`}</code></pre>
    <h2 {...{
      "id": "applying-customizations"
    }}>{`Applying Customizations`}</h2>
    <p>{`To apply the customizations to the content card templates, pass the customizer to the `}<inlineCode parentName="p">{`getContentCardsUI`}</inlineCode>{` API. The customizer will be called for each content card template type that is recognized by the Messaging extension.`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages="Swift" mdxType="CodeBlock" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let homePageSurface = Surface(path: "homepage")
let homePageCardCustomizer = HomePageCardCustomizer()
Messaging.getContentCardsUI(for: homePageSurface,
                             customizer: homePageCardCustomizer) { result in
    // handle result
}
`}</code></pre>
    <p>{`Customize the content card templates for different surfaces by creating a customizer for each surface. For example, the following code snippet customizes the content card templates for the "homepage" and "detailpage" content cards separately:`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages="Swift" mdxType="CodeBlock" />
    <h4 {...{
      "id": "swift-2"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let homePageSurface = Surface(path: "homepage")
let homePageCustomizer = HomePageCardCustomizer()
Messaging.getContentCardsUI(for: homePageSurface,
                             customizer: homePageCustomizer) { result in
    // handle result
}

let detailPageSurface = Surface(path: "detailpage")
let detailPageCustomizer = DetailPageCardCustomizer()
Messaging.getContentCardsUI(for: detailPageSurface,
                             customizer: detailPageCustomizer) { result in
    // handle result
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      